import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { IIdTitle, IdTitle } from "ui/Scripts/source/models/common/idTitle";
import { IIdTitleNode, IdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { ApplicationPermissionType, EnumHelper, RecordEmployeeType, ReportSharingType, ReportType } from "ui/Scripts/source/models/enums";
import { ITaskDataRow } from "ui/Scripts/source/models/task/taskDataRow";
import { ITaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";
import { Translations } from "ui/Scripts/source/models/translations";
import { IIdTitleClass, IdTitleClass } from "ui/Scripts/source/models/common/idTitleClass";
import { IChartItem } from "source/models/chart/chartItem";
import { IListFilterItem, ListFilterItem } from "source/models/common/listFilterItem";
import { IPagePanel } from "source/models/common/pagePanel";
import { ISavedListFilter } from "source/models/common/savedListFilter";
import { ITypedOption } from "source/models/common/typedOption";
import { IRecordEditItemQualification } from "source/models/record/recordEditItemQualification";
import { IRecordPageList } from "source/models/record/recordPageList";
import { IReportItem, ReportItem } from "source/models/report/reportItem";
import { getStateChangeAfterChangeActiveReport, getStateChangeAfterChangeActiveSavedReport, handleRemoveSavedReport, ReportItems } from "source/models/report/reportItems";
import { ISavedReport } from "source/models/report/savedReport";
import * as recordService from "source/models/services/recordService";
import { ISessionState } from "source/models/session/sessionState";
import { IAppSessionState } from "source/models/store/storeTypes";
import { IUnitModuleNode } from "source/models/unit/unitModuleNode";
import { IUnitNodePermissions } from "source/models/unit/unitNodePermissions";
import { DashboardPanelList } from "source/components/app/DashboardPanelList";
import { HeaderMenuItem, NavigationMenu } from "source/components/app/NavigationMenu";
import { UserMenu } from "source/components/app/UserMenu";
import { ListFilterSaveDialog } from "source/components/framework/Filters/ListFilterSaveDialog";
import { PageContainer } from "source/components/framework/Page/PageContainer";
import { PageContent } from "source/components/framework/Page/PageContent";
import { PageDashboard } from "source/components/framework/Page/PageDashboard";
import { PageListAndReportsContainer } from "source/components/framework/Page/PageListAndReportsContainer";
import { PageReportsContainer } from "source/components/framework/Page/PageReportsContainer";
import { PageTabs } from "source/components/framework/Page/PageTabs";
import { PageTopBar } from "source/components/framework/Page/PageTopBar";
import { IPageNavMenuItem } from "source/components/framework/PageNav/PageNavMenuItems";
import { FilterTabs } from "source/components/framework/PageNavMenuItem/FilterTabs";
import { ReportSettings } from "source/components/framework/ReportSettings";
import { PageNavMenuReportList } from "source/components/report/PageNavMenuItemReportList/PageNavMenuItemReportList";
import { ISaveReportFilters, SaveReportDialog } from "source/components/report/PageNavMenuItemReportList/SaveReportDialog";
import { RecordPageListFilterDrawer } from "./RecordPageListFilterDrawer";
import { RecordList } from "source/components/record/RecordList";
import { RecordPageListReportFilterPanel } from "./RecordPageListReportFilterPanel";
import { RecordPageListReport } from "./RecordPageListReport";
import RecordSettingsDialog, { RecordSettingsDialogMenuItem } from "source/components/record/RecordSettingsDialog/RecordSettingsDialog";
import { IRecordCompanyFurtherEducationGroups, RecordCompanyFurtherEducationGroups } from "ui/Scripts/source/models/recordFurtherEducationGroup/recordCompanyFurtherEducationGroups";
import { IRecordCompanyRecordFamiliarizationListItems, RecordCompanyRecordFamiliarizationListItems } from "source/models/record/recordCompanyRecordFamiliarizationListItems";
import { IFrontToDoItem } from "source/models/front/frontToDoItem";
import { TDefaultListFilter } from "source/models/common/defaultListFilter";
import { IRecordListState, IRecordReportState, setRecordListDefaultFilter, setRecordReportDefaultFilter } from "source/models/store/record";
import { TDefaultReportFilter } from "source/models/common/defaultReportFilter";
import { getRecordActivityFilters, RecordPageListActivityFilterId } from "./RecordPageListUtils";

/* eslint-disable no-unused-vars */
export const enum RecordPageListViewTypeId {
    Records = "0",
    Reports = "1",
    Dashboard = "2",
}

const enum HtmlReportId {
    ExpiredFamiliarizations = "HtmlReportExpiredFamiliarizations",
    ExpiredFurtherEducations = "HtmlReportExpiredFurtherEducations",
}
/* eslint-enable no-unused-vars */

// RecordPageList
export interface IRecordPageListProps {
    appState: IAppSessionState;
    list: IRecordListState;
    report: IRecordReportState;
    dataId: number;
    page: string;
    pageList: IRecordPageList;
    onGetRecordsPage: () => void;
    onLogout: () => void;
    onSetCulture: (culture: string) => void;
    onSaveUserParameters: (parameters: ITypedOption[]) => void;
    onRefreshSessionState: () => void;
}

interface IRecordPageListState {
    initialized: boolean;
    showDashBoardNavPanel: boolean;
    dashBoardPanels: IPagePanel[];
    viewTypes: IIdTitleClass[];
    units: IIdTitleNode[];
    companyFurtherEducationGroups: IRecordCompanyFurtherEducationGroups[];
    recordQualifications: IRecordEditItemQualification[];
    companyFamiliarizations: IRecordCompanyRecordFamiliarizationListItems[];
    activityFilters: IIdTitle[];
    reportActivityFilters: IIdTitle[];
    jobTitles: IIdTitle[];
    employeeTypes: IIdTitle[];
    sheetTaskType: ITaskEditTypeItem;
    hasExplicitRecordPartners: boolean;
    showNavPanel: boolean;
    activeViewTypeId: string;
    activeCompanyId: string;
    selectedActivityFilterId: string;
    selectedUnitIds: string[];
    selectedJobTitleIds: string[];
    selectedEmployeeTypeIds: string[];
    sortColumn: string;
    sortOrderIsAsc: boolean;
    settingsActions: IPageNavMenuItem[];
    // Filters
    listFilterIsSet: boolean;
    showRecordFilterDialog: boolean;
    recordFilterDialogFilter: IListFilterItem;
    filters: IListFilterItem[];
    savedFilters: IListFilterItem[];
    activeFilterId: string;
    activeSavedFilterId: string;
    showListFilterSaveDialog: boolean;
    listFilterSaveDialogFilter: IListFilterItem;
    listFilterSaveDialogGeneralFilter: any;
    listFilterSaveDialogReservedNames: string[];
    listFilterSaveDialogOnGetGeneralFilter: () => any;
    // Properties
    showSettingsDialog: boolean;
    dataId: number;
    unitNodePermissions: IUnitNodePermissions;
    familiarizationsDialogCompanyId: string;
    educationsDialogCompanyId: string;
    unitModuleDialogNode: IUnitModuleNode;
    // Reports
    loadingReports: boolean;
    reports: IReportItem[];
    savedReports: IReportItem[];
    reportChartItems: IChartItem[]; //Not in use
    activeReportId: string;
    activeSavedReportId: string;
    reportFilterReport: IReportItem;
    showReportSaveDialog: boolean;
    reportSaveDialogReport: IReportItem;
    reportSaveDialogGeneralFilter: any;
    reportSaveDialogReservedNames: string[];
    reportSaveDialogOnGetReportSaveFilters: () => ISaveReportFilters;
}

export class RecordPageList extends React.Component<IRecordPageListProps, IRecordPageListState> {
    _isMounted: boolean;

    static getViewTypes = (): IIdTitleClass[] => {
        const result: IIdTitleClass[] = [];
        result.push(IdTitleClass.createIdTitleClass(RecordPageListViewTypeId.Dashboard, Translations.FrontPage, "home"));
        result.push(IdTitleClass.createIdTitleClass(RecordPageListViewTypeId.Records, Translations.Resources, "list2"));
        result.push(IdTitleClass.createIdTitleClass(RecordPageListViewTypeId.Reports, Translations.Reports, "report"));
        return result;
    };

    static getEmployeeTypes = (): IIdTitle[] => {
        const result: IIdTitle[] = [];
        result.push(IdTitle.createIdTitle("", "'" + Translations.All + "'"));
        result.push(IdTitle.createIdTitle(RecordEmployeeType.Intern.toString(10), EnumHelper.RecordEmployeeTypeToStr(RecordEmployeeType.Intern)));
        result.push(IdTitle.createIdTitle(RecordEmployeeType.Employee.toString(10), EnumHelper.RecordEmployeeTypeToStr(RecordEmployeeType.Employee)));
        result.push(IdTitle.createIdTitle(RecordEmployeeType.AgencyWorker.toString(10), EnumHelper.RecordEmployeeTypeToStr(RecordEmployeeType.AgencyWorker)));
        result.push(IdTitle.createIdTitle(RecordEmployeeType.SeasonalWorker.toString(10), EnumHelper.RecordEmployeeTypeToStr(RecordEmployeeType.SeasonalWorker)));
        result.push(IdTitle.createIdTitle(RecordEmployeeType.Entrepreneur.toString(10), EnumHelper.RecordEmployeeTypeToStr(RecordEmployeeType.Entrepreneur)));
        result.push(IdTitle.createIdTitle(RecordEmployeeType.Other.toString(10), EnumHelper.RecordEmployeeTypeToStr(RecordEmployeeType.Other)));
        return result;
    };

    getSettingsActions = (sessionState: ISessionState, activeCompanyId: string, hasExplicitRecordPartners: boolean): IPageNavMenuItem[] => {
        const result: IPageNavMenuItem[] = [];
        if (sessionState.isCompanyAdmin) {
            result.push({ id: RecordSettingsDialogMenuItem.Units, title: Translations.Units });
            result.push({ id: RecordSettingsDialogMenuItem.Permissions, title: Translations.Permissions });
        }
        result.push({ id: RecordSettingsDialogMenuItem.Familiarizations, title: Translations.Familiarizations });
        result.push({ id: RecordSettingsDialogMenuItem.BasicEducations, title: Translations.BasicEducations });
        result.push({ id: RecordSettingsDialogMenuItem.FurtherEducations, title: Translations.FurtherEducations + " / " + Translations.Competencies });
        if (sessionState.isCompanyAdmin) {
            result.push({ id: RecordSettingsDialogMenuItem.Settings, title: Translations.RecordUserSettings });
        }
        if (sessionState.isCompanyAdmin && hasExplicitRecordPartners || sessionState.isSuperAdmin) {
            result.push({ id: RecordSettingsDialogMenuItem.RecordUserPartners, title: Translations.RecordUserPartners });
        }
        if (sessionState.isSuperAdmin && sessionState.companyId === activeCompanyId) {
            result.push({ id: RecordSettingsDialogMenuItem.DefaultFamiliarizations, title: Translations.DefaultFamiliarizations });
            result.push({ id: RecordSettingsDialogMenuItem.DefaultBasicEducations, title: Translations.DefaultBasicEducations });
            result.push({ id: RecordSettingsDialogMenuItem.DefaultFurtherEducations, title: Translations.DefaultFurtherEducations + " / " + Translations.Competencies });
        }
        return result;
    };

    getIdTitleNodes = (units: IIdTitleNode[]): IIdTitleNode[] => {
        const result: IIdTitleNode[] = [];
        result.push(IdTitleNode.createIdTitleNode(Base.emptyGuid, "'" + Translations.All + "'", []));
        result.push(IdTitleNode.createIdTitleNode("00000000-0000-0000-0000-000000000001", "'" + Translations.NotSet + "'", []));
        return result.concat(units);
    };

    getJobTitles = (jobTitles: string[]): IIdTitle[] => {
        const result: IIdTitle[] = [];
        result.push(IdTitle.createIdTitle("", "'" + Translations.All + "'"));
        return result.concat(jobTitles.map(i => IdTitle.createIdTitle(i, i)));
    };

    getHtlmlReportItems = (): IReportItem[] => {
        const result: IReportItem[] = [];
        result.push(ReportItem.createReportItem(HtmlReportId.ExpiredFamiliarizations, Translations.ExpiredFamiliarizations, ReportType.Html, null));
        result.push(ReportItem.createReportItem(HtmlReportId.ExpiredFurtherEducations, Translations.ExpiredFurtherEducations, ReportType.Html, null));
        return ReportItem.sortReportItems(result);
    };

    getListFilterIsSet = (state: IRecordPageListState): boolean => {
        return RecordPageListFilterDrawer.filterIsSet(state.activityFilters, state.employeeTypes, state.jobTitles, state.units,
            state.selectedActivityFilterId, state.selectedEmployeeTypeIds, state.selectedJobTitleIds, state.selectedUnitIds);
    };

    getFilters = (): IListFilterItem[] => {
        const result: IListFilterItem[] = [];
        result.push(ListFilterItem.createListFilterItem(Translations.UserRecords, Translations.UserRecords, {
            activityFilterId: RecordPageListActivityFilterId.Active,
            employeeTypeIds: [],
            jobTitleIds: [],
            unitIds: []
        }, "lastName", true));
        ListFilterItem.sortListFilterItems(result);
        return result;
    };

    getSavedFilters = (props: IRecordPageListProps): IListFilterItem[] => {
        const result: IListFilterItem[] = [];
        if (!props || !props.pageList) return result;
        for (const companyFilter of props.pageList.companyFilters) {
            result.push(ListFilterItem.createListFilterItemFromSavedListFilter(companyFilter, true));
        }
        for (const userFilter of props.pageList.userFilters) {
            result.push(ListFilterItem.createListFilterItemFromSavedListFilter(userFilter, false));
        }
        ListFilterItem.sortListFilterItems(result);
        return result;
    };

    getDefaultRecordPageListViewTypeId = (props: IRecordPageListProps): RecordPageListViewTypeId => {
        if (!props.page) return RecordPageListViewTypeId.Dashboard;
        if (props.page.equalIgnoreCase("list")) return RecordPageListViewTypeId.Records;
        if (props.page.equalIgnoreCase("reports")) return RecordPageListViewTypeId.Reports;
        return RecordPageListViewTypeId.Dashboard;
    };

    constructor(props: IRecordPageListProps) {
        super(props);
        const sessionState = props.appState.state;
        const filters = this.getFilters();
        const filter = (props.list.defaultFilter?.filterId
            ? filters.find(i => i.id === props.list.defaultFilter.filterId)
            : filters[0]) ?? filters[0];
        const intialFilter = new ListFilterItem(filter);
        if (props.list.defaultFilter?.generalFilter) {
            intialFilter.generalFilter = { ...intialFilter.generalFilter, ...props.list.defaultFilter.generalFilter };
        }
        const filterProps = ListFilterItem.getFilterProps(intialFilter, "", true, this.getStateFilterPropsFromGeneralFilter);
        const reports = this.getHtlmlReportItems();
        const activeReportId = props.report.defaultFilter?.reportId
            ? props.report.defaultFilter.reportId
            : reports[0].id;
        const hasExplicitRecordPartners = !!props.pageList?.hasExplicitRecordPartners;
        const state = {
            ...filterProps,
            initialized: !!props.pageList,
            dashBoardPanels: props.pageList ? props.pageList.panels : [],
            showDashBoardNavPanel: false,
            viewTypes: RecordPageList.getViewTypes(),
            activityFilters: getRecordActivityFilters(false),
            reportActivityFilters: getRecordActivityFilters(true),
            units: this.getIdTitleNodes(props.pageList ? props.pageList.units : []),
            companyFurtherEducationGroups: props.pageList ? props.pageList.companyFurtherEducationGroups : [],
            companyFamiliarizations: props.pageList ? props.pageList.companyFamiliarizations : [],
            employeeTypes: RecordPageList.getEmployeeTypes(),
            jobTitles: this.getJobTitles(props.pageList ? props.pageList.jobTitles : []),
            sheetTaskType: props.pageList ? props.pageList.sheetTaskType : null,
            hasExplicitRecordPartners,
            showNavPanel: sessionState.getShowPageNavigation(),
            activeViewTypeId: this.getDefaultRecordPageListViewTypeId(props),
            activeCompanyId: sessionState.companyId,
            // Filters
            activeFilterId: filter.id,
            activeSavedFilterId: "",
            filters,
            savedFilters: this.getSavedFilters(props),
            showRecordFilterDialog: false,
            recordFilterDialogFilter: null,
            showListFilterSaveDialog: false,
            listFilterSaveDialogFilter: null,
            listFilterSaveDialogGeneralFilter: null,
            listFilterSaveDialogReservedNames: [],
            listFilterSaveDialogOnGetGeneralFilter: null,
            settingsActions: this.getSettingsActions(sessionState, sessionState.companyId, hasExplicitRecordPartners),
            // Properties
            showSettingsDialog: false,
            dataId: 0,
            unitNodePermissions: null,
            familiarizationsDialogCompanyId: sessionState.companyId,
            educationsDialogCompanyId: sessionState.companyId,
            unitModuleDialogNode: null,
            // Statistics
            loadingStatistics: true,
            statistics: null,
            // Reports
            loadingReports: true,
            reports,
            savedReports: [],
            reportChartItems: [], //Not in use
            activeReportId,
            activeSavedReportId: "",
            reportFilterReport: null,
            showReportSaveDialog: false,
            reportSaveDialogReport: null,
            reportSaveDialogGeneralFilter: null,
            reportSaveDialogReservedNames: [],
            reportSaveDialogOnGetReportSaveFilters: null
        };
        this.state = {
            ...state,
            listFilterIsSet: this.getListFilterIsSet(state)
        };
        setRecordListDefaultFilter(null);
    }

    getReports = async (companyId: string) => {
        const state = this.state;
        const newState = await ReportItems.getReportsState(companyId, state.activeReportId, state.activeSavedReportId, this.getHtlmlReportItems(), recordService.getRecordPageReportItems,
            () => {
                if (!this._isMounted) return;
                this.setState({ loadingReports: true });
            },
            () => {
                if (!this._isMounted) return;
                this.setState({ loadingReports: false });
            });
        if (!this._isMounted || !newState) return;
        this.setState({
            ...newState,
        }, () => {
            this.handleChangeActiveReport(newState.activeReportId, this.props.report.defaultFilter?.generalFilter, this.props.report.defaultFilter?.reportFilter);
            setRecordReportDefaultFilter(null);
        });
    };

    async componentDidMount(): Promise<void> {
        await this.props.onGetRecordsPage();
        this.getReports(null);
        this._isMounted = true;
    }

    componentDidUpdate(prevProps: IRecordPageListProps, prevState: IRecordPageListState): void {
        const props = this.props;
        const state = this.state;
        const sessionState = props.appState.state;
        const prevCompanyIds = (prevProps.pageList ? prevProps.pageList.companies.map(i => i.id) : []).join(",");
        const companyIds = (props.pageList ? props.pageList.companies.map(i => i.id) : []).join(",");
        const prevCompanyId = prevProps.pageList && prevProps.pageList.companies.length > 0 ? prevProps.pageList.companies[0].id : Base.emptyGuid;
        const companyId = props.pageList && props.pageList.companies.length > 0 ? props.pageList.companies[0].id : Base.emptyGuid;
        const prevUnitsData = prevProps.pageList ? prevProps.pageList.units : [];
        const unitsData = props.pageList ? props.pageList.units : [];
        const equalUnits = IdTitleNode.equalIdsInArrays(prevUnitsData, unitsData);
        const units = this.getIdTitleNodes(unitsData);
        const prevCompanyFurtherEducationGroups = prevProps.pageList ? prevProps.pageList.companyFurtherEducationGroups : [];
        const companyFurtherEducationGroups = props.pageList ? props.pageList.companyFurtherEducationGroups : [];
        const equalCompanyFurtherEducationGroups = RecordCompanyFurtherEducationGroups.equalIdsInFurtherEducationGroups(prevCompanyFurtherEducationGroups, companyFurtherEducationGroups);
        const prevCompanyFamiliarizations = prevProps.pageList ? prevProps.pageList.companyFamiliarizations : [];
        const companyFamiliarizations = props.pageList ? props.pageList.companyFamiliarizations : [];
        const equalCompanyFamiliarizations = RecordCompanyRecordFamiliarizationListItems.equalIdsInFamiliarizations(prevCompanyFamiliarizations, companyFamiliarizations);
        const jobTitlesData = props.pageList ? props.pageList.jobTitles : [];
        const jobTitles = this.getJobTitles(jobTitlesData);
        const equalJobTitles = Base.equalStrArrays(prevProps.pageList?.jobTitles, jobTitlesData);
        const prevHasSheet = !!prevProps.pageList?.sheetTaskType?.id;
        const sheetTaskType = props.pageList ? props.pageList.sheetTaskType : null;
        const hasSheet = !!sheetTaskType?.id;
        const prevHasExplicitRecordPartners = !!prevProps.pageList?.hasExplicitRecordPartners;
        const hasExplicitRecordPartners = !!props.pageList?.hasExplicitRecordPartners;
        if (prevProps.dataId === props.dataId && prevCompanyId === companyId && prevCompanyIds === companyIds && equalUnits &&
            equalCompanyFurtherEducationGroups && equalCompanyFamiliarizations && equalJobTitles && prevHasSheet === hasSheet &&
            prevHasExplicitRecordPartners === hasExplicitRecordPartners) return;
        const selectedUnitIds = equalUnits ? state.selectedUnitIds : [Base.emptyGuid];
        const selectedJobTitleIds = equalJobTitles ? state.selectedJobTitleIds : [""];
        const savedFilters = this.getSavedFilters(props);
        const activeSavedFilterId = savedFilters.find(i => i.id === state.activeSavedFilterId)
            ? state.activeSavedFilterId
            : "";
        const stateChange = {
            initialized: !!props.pageList,
            dataId: props.dataId,
            dashBoardPanels: props.pageList ? props.pageList.panels : [],
            showNavPanel: state.initialized ? state.showNavPanel : sessionState.getShowPageNavigation(),
            activeCompanyId: companyId,
            units,
            companyFurtherEducationGroups,
            companyFamiliarizations,
            jobTitles,
            sheetTaskType,
            hasExplicitRecordPartners,
            selectedUnitIds,
            selectedJobTitleIds,
            savedFilters,
            activeSavedFilterId,
            settingsActions: this.getSettingsActions(sessionState, companyId, hasExplicitRecordPartners),
        };
        const newState = { ...state, ...stateChange };
        this.setState({
            ...stateChange,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
    }

    componentWillUnmount(): void {
        this._isMounted = false;
    }
    
    handleToggleShowNavPanel = () => {
        this.setState({ showNavPanel: !this.state.showNavPanel });
    };
    
    handleChangeActiveCompanyId = async (companyId: string) => {
        const state = this.state;
        if (state.activeCompanyId === companyId) return;
        const sessionState = this.props.appState.state;
        const recordPageData = await recordService.getRecordPageUnitsAndJobTitles(companyId);
        const stateChange = {
            activeCompanyId: companyId,
            units: this.getIdTitleNodes(recordPageData.units),
            companyFurtherEducationGroups: recordPageData.companyFurtherEducationGroups,
            companyFamiliarizations: recordPageData.companyFamiliarizations,
            selectedUnitIds: [Base.emptyGuid],
            jobTitles: this.getJobTitles(recordPageData.jobTitles),
            sheetTaskType: recordPageData.sheetTaskType,
            hasExplicitRecordPartners: recordPageData.hasExplicitRecordPartners,
            selectedJobTitleIds: [""],
            settingsActions: this.getSettingsActions(sessionState, companyId, recordPageData.hasExplicitRecordPartners),
        };
        const newState = { ...state, ...stateChange };
        this.setState({
            ...stateChange,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
        this.getReports(companyId);
    };
    
    updateFurtherEducationsFamiliarizationsAndJobTitles = async (companyId: string) => {
        if (!companyId) return;
        const recordPageData = await recordService.getRecordPageUnitsAndJobTitles(companyId);
        this.setState({
            units: this.getIdTitleNodes(recordPageData.units),
            companyFurtherEducationGroups: recordPageData.companyFurtherEducationGroups,
            companyFamiliarizations: recordPageData.companyFamiliarizations,
            jobTitles: this.getJobTitles(recordPageData.jobTitles),
            sheetTaskType: recordPageData.sheetTaskType,
            hasExplicitRecordPartners: recordPageData.hasExplicitRecordPartners
        });
    };

    handleSetSelectedActivityFilterId = (selectedActivityFilterId: string) => {
        const newState = { ...this.state, selectedActivityFilterId };
        this.setState({
            selectedActivityFilterId,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
    };

    handleSetSelectedUnitIds = (selectedUnitIds: string[]) => {
        const newState = { ...this.state, selectedUnitIds };
        this.setState({
            selectedUnitIds,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
    };

    handleToggleEmployeeType = (employeeType: string, checked: boolean) => {
        const state = this.state;
        const selectedEmployeeTypeIds = Base.getToggledMultiSelectIds(state.employeeTypes, state.selectedEmployeeTypeIds, employeeType, checked);
        const newState = { ...state, selectedEmployeeTypeIds };
        this.setState({
            selectedEmployeeTypeIds,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
    };

    handleToggleJobTitle = (jobTitle: string, checked: boolean) => {
        const state = this.state;
        const selectedJobTitleIds = Base.getToggledMultiSelectIds(state.jobTitles, state.selectedJobTitleIds, jobTitle, checked);
        const newState = { ...state, selectedJobTitleIds };
        this.setState({
            selectedJobTitleIds,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
    };

    // #region Saved Filter
    getGeneralFilterFromState = (state: IRecordPageListState): any => {
        return {
            activityFilterId: state.selectedActivityFilterId ? parseInt(state.selectedActivityFilterId, 10) : 0,
            employeeTypeIds: state.selectedEmployeeTypeIds ? state.selectedEmployeeTypeIds.filter(i => !Base.isNullOrEmpty(i)) : [],
            jobTitleIds: state.selectedJobTitleIds ? state.selectedJobTitleIds.filter(i => !!i) : [],
            unitIds: state.selectedUnitIds ? state.selectedUnitIds.filter(i => i !== Base.emptyGuid) : []
        };
    };

    getStateFilterPropsFromGeneralFilter = (generalFilter: any): any => {
        return {
            selectedActivityFilterId: generalFilter && !Base.isNullOrUndefined(generalFilter.activityFilterId) ? generalFilter.activityFilterId.toString(10) : RecordPageListActivityFilterId.Active,
            selectedEmployeeTypeIds: generalFilter && generalFilter.employeeTypeIds && generalFilter.employeeTypeIds.length > 0 ? generalFilter.employeeTypeIds : [""],
            selectedJobTitleIds: generalFilter && generalFilter.jobTitleIds && generalFilter.jobTitleIds.length > 0 ? generalFilter.jobTitleIds : [""],
            selectedUnitIds: generalFilter && generalFilter.unitIds && generalFilter.unitIds.length > 0 ? generalFilter.unitIds : [Base.emptyGuid]
        };
    };
    
    getFilterPropsWithState = (listItemFilter: IListFilterItem, additionalGeneralFilter: any = null) => {
        const state = this.state;
        let result = {
            selectedActivityFilterId: state.selectedActivityFilterId,
            selectedEmployeeTypeIds: state.selectedEmployeeTypeIds,
            selectedJobTitleIds: state.selectedJobTitleIds,
            selectedUnitIds: state.selectedUnitIds,
            sortColumn: state.sortColumn,
            sortOrderIsAsc: state.sortOrderIsAsc
        };
        if (listItemFilter) {
            const filter = new ListFilterItem(listItemFilter);
            if (additionalGeneralFilter) {
                filter.generalFilter = { ...filter.generalFilter, ...additionalGeneralFilter };
            }
            result = ListFilterItem.getFilterProps(filter, result.sortColumn, result.sortOrderIsAsc, this.getStateFilterPropsFromGeneralFilter);
        }
        return result;
    };

    getStateChangeAfterChangeActiveFilter = (activeFilterId: string, additionalGeneralFilter: any = null): any => {
        const state = this.state;
        const filter = state.filters.find(i => i.id === activeFilterId);
        if (!filter) return;
        const filterProps = this.getFilterPropsWithState(filter, additionalGeneralFilter);
        const activeSavedFilterId = "";
        const newState = { ...state, ...filterProps, activeFilterId, activeSavedFilterId };
        return {
            ...filterProps,
            activeFilterId,
            activeSavedFilterId: "",
            listFilterIsSet: this.getListFilterIsSet(newState)
        };
    };

    handleChangeActiveFilter = (activeFilterId: string) => {
        this.setState(this.getStateChangeAfterChangeActiveFilter(activeFilterId));
    };

    getStateChangeAfterChangeActiveSavedFilter = (activeSavedFilterId: string): any => {
        const state = this.state;
        const savedFilter = state.savedFilters.find(i => i.id === activeSavedFilterId);
        if (!savedFilter) return;
        const filterProps = this.getFilterPropsWithState(savedFilter);
        const activeFilterId = "";
        const newState = { ...state, ...filterProps, activeFilterId, activeSavedFilterId };
        return {
            ...filterProps,
            activeFilterId,
            activeSavedFilterId,
            listFilterIsSet: this.getListFilterIsSet(newState)
        };
    };

    handleChangeActiveSavedFilter = (activeSavedFilterId: string) => {
        this.setState(this.getStateChangeAfterChangeActiveSavedFilter(activeSavedFilterId));
    };

    handleRemoveSavedFilter = async (savedFilterId: string) => {
        const state = this.state;
        const savedFilter = state.savedFilters.find(i => i.id === savedFilterId);
        if (!savedFilter) return;
        const result = await ListFilterSaveDialog.removeListFilterFromDb(state.savedFilters, state.activeCompanyId, savedFilterId, savedFilter.isShared, ApplicationPermissionType.Record);
        if (!result) return;
        const savedFilters = state.savedFilters.filter(i => i.id !== savedFilterId);
        let activeFilterId = "";
        let activeSavedFilterId = "";
        let newfilter: IListFilterItem = null;
        if (savedFilters.length > 0) {
            newfilter = savedFilters[0];
            activeSavedFilterId = newfilter.id;
        } else if (state.filters.length > 0) {
            newfilter = state.filters[0];
            activeFilterId = newfilter.id;
        }
        const filterProps = this.getFilterPropsWithState(newfilter);
        const newState = { ...state, ...filterProps, activeFilterId, activeSavedFilterId, savedFilters };
        this.setState({
            ...filterProps,
            showRecordFilterDialog: false,
            activeFilterId,
            activeSavedFilterId,
            savedFilters,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
    };

    handleFilterSortData = (sortColumn: string, sortOrderIsAsc: boolean) => {
        this.setState({
            sortColumn,
            sortOrderIsAsc,
        });
    };

    handleEmploymentSaved = () => {
        this.updateFurtherEducationsFamiliarizationsAndJobTitles(this.state.activeCompanyId);
    };

    updateFiltersAfterSave = (orgFilterId: string, savedListFilter: ISavedListFilter, isShared: boolean) => {
        if (!savedListFilter) return;
        const state = this.state;
        const savedFilters = state.savedFilters.filter(i => i.id !== orgFilterId || i.isShared !== isShared);
        const filter = ListFilterItem.createListFilterItemFromSavedListFilter(savedListFilter, isShared);
        savedFilters.push(filter);
        ListFilterItem.sortListFilterItems(savedFilters);
        this.setState({
            showListFilterSaveDialog: false,
            savedFilters,
            activeFilterId: "",
            activeSavedFilterId: savedListFilter.id,
            recordFilterDialogFilter: filter
        });
    };

    getActiveFilter = (): IListFilterItem => {
        const state = this.state;
        return state.activeFilterId
            ? state.filters.find(i => i.id === state.activeFilterId)
            : state.savedFilters.find(i => i.id === state.activeSavedFilterId);
    };

    handleSaveListFilter = async (saveAs: boolean, onGetGeneralFilter: () => any) => {
        const state = this.state;
        const filter = this.getActiveFilter();
        if (!filter) return;
        if (!saveAs) {
            const savedListFilter = await ListFilterSaveDialog.saveListFilterToDb(filter, this.getGeneralFilterFromState(state), state.sortColumn, state.sortOrderIsAsc, state.activeCompanyId, ApplicationPermissionType.Record);
            this.updateFiltersAfterSave(filter.id, savedListFilter, filter.isShared);
        } else {
            this.setState({
                showListFilterSaveDialog: true,
                listFilterSaveDialogFilter: filter,
                listFilterSaveDialogReservedNames: state.savedFilters.map(i => i.id).concat(state.filters.map(i => i.title)),
                listFilterSaveDialogGeneralFilter: this.getGeneralFilterFromState(state),
                listFilterSaveDialogOnGetGeneralFilter: onGetGeneralFilter
            });
        }
    };

    handleSaveListFilterDialogOk = (savedListFilter: ISavedListFilter, isShared: boolean) => {
        this.updateFiltersAfterSave("", savedListFilter, isShared);
    };

    handleSaveListFilterDialogCancel = () => {
        this.setState({
            showListFilterSaveDialog: false
        });
    };
    // #endregion Saved Filter

    // #region Record Filter
    handleOpenRecordFilterDialog = () => {
        const filter = this.getActiveFilter();
        if (!filter) return;
        this.setState({
            showRecordFilterDialog: true,
            recordFilterDialogFilter: filter
        });
    };

    onRecordFilterDialogOk = (closeDialog: boolean, selectedActivityFilterId: string, selectedEmployeeTypeIds: string[], selectedJobTitleIds: string[], selectedUnitIds: string[]): any => {
        const newState = { ...this.state, selectedActivityFilterId, selectedEmployeeTypeIds, selectedJobTitleIds, selectedUnitIds };
        this.setState({
            showRecordFilterDialog: !closeDialog,
            selectedActivityFilterId,
            selectedEmployeeTypeIds,
            selectedJobTitleIds,
            selectedUnitIds,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
        return this.getGeneralFilterFromState(newState);
    };
    
    onRecordFilterDialogCancel = () => {
        this.setState({ showRecordFilterDialog: false });
    };
    // #endregion Record Filter

    // #region Report
    getStateChangeAfterChangeActiveReport = (activeReportId: string, additionalGeneralFilter: any = null, additionalReportFilter: any = null): any => {
        return getStateChangeAfterChangeActiveReport(
            this.state,
            this.getStateFilterPropsFromGeneralFilter,
            this.getListFilterIsSet,
            activeReportId,
            additionalGeneralFilter,
            additionalReportFilter
        );
    };

    handleChangeActiveReport = (activeReportId: string, additionalGeneralFilter: any = null, additionalReportFilter: any = null) => {
        this.setState(this.getStateChangeAfterChangeActiveReport(activeReportId, additionalGeneralFilter, additionalReportFilter));
    };

    getStateChangeAfterChangeActiveSavedReport = (activeSavedReportId: string): any => {
        return getStateChangeAfterChangeActiveSavedReport(
            this.state,
            this.getStateFilterPropsFromGeneralFilter,
            this.getListFilterIsSet,
            activeSavedReportId);
    };

    handleChangeActiveSavedReport = (activeSavedReportId: string) => {
        this.setState(this.getStateChangeAfterChangeActiveSavedReport(activeSavedReportId));
    };

    handleRemoveSavedReport = async (reportId: string) => {
        this.setState(await handleRemoveSavedReport(
            this.state,
            this.getStateFilterPropsFromGeneralFilter,
            this.getListFilterIsSet,
            ApplicationPermissionType.Record,
            SaveReportDialog.removeReportFromDb,
            reportId
        ));
    };
    // #endregion Report

    // #region Settings
    handleOpenSettingsDialog = () => {
        this.setState({
            showSettingsDialog: true
        });
    };

    handleSettingsDialogOk = async () => {
        this.setState({
            showSettingsDialog: false,
            dataId: this.state.dataId + 1
        });
        await this.updateFurtherEducationsFamiliarizationsAndJobTitles(this.state.activeCompanyId);
    };
    // #endregion Settings

    handleSetActiveViewType = (itemId: RecordPageListViewTypeId, activeFilterOrReportId: string = null, additionalGeneralFilter: any = null, additionalReportFilter: any = null) => {
        const state = this.state;
        //To reset filter when filter/report is activated
        let newState = {};
        if (itemId === RecordPageListViewTypeId.Reports) {
            if (activeFilterOrReportId ?? state.activeReportId) {
                newState = this.getStateChangeAfterChangeActiveReport(activeFilterOrReportId ?? state.activeReportId, additionalGeneralFilter, additionalReportFilter);
            } else if (state.activeSavedReportId) {
                newState = this.getStateChangeAfterChangeActiveSavedReport(state.activeSavedReportId);
            }
        } else if (itemId === RecordPageListViewTypeId.Records) {
            if (activeFilterOrReportId ?? state.activeFilterId) {
                newState = this.getStateChangeAfterChangeActiveFilter(activeFilterOrReportId ?? state.activeFilterId, additionalGeneralFilter);
            } else if (state.activeSavedFilterId) {
                newState = this.getStateChangeAfterChangeActiveSavedFilter(state.activeSavedFilterId);
            }
        }
        this.setState({
            ...newState,
            activeViewTypeId: itemId
        });
    };

    // #region Report Filter
    getActiveReport = (): IReportItem => {
        const state = this.state;
        return state.activeReportId
            ? state.reports.find(i => i.id === state.activeReportId)
            : state.savedReports.find(i => i.id === state.activeSavedReportId);
    };

    onRecordReportFilterDialogOk = (closeDialog: boolean, selectedActivityFilterId: string, selectedEmployeeTypeIds: string[], selectedJobTitleIds: string[], selectedUnitIds: string[], parameters: ITaskDataRow): ISaveReportFilters => {
        const state = this.state;
        const reports = state.reports.slice(0);
        const savedReports = state.savedReports.slice(0);
        const index = state.activeReportId
            ? reports.findIndex(i => i.id === state.activeReportId)
            : savedReports.findIndex(i => i.id === state.activeSavedReportId);
        if (index < 0) return;
        let reportFilter = null;
        if (state.activeReportId) {
            const report = new ReportItem(reports[index]);
            report.taskDataRow = parameters;
            report.reportFilter = SaveReportDialog.getReportFilter(report);
            reportFilter = report.reportFilter;
            reports[index] = report;
        } else {
            const savedReport = new ReportItem(savedReports[index]);
            savedReport.taskDataRow = parameters;
            savedReport.reportFilter = SaveReportDialog.getReportFilter(savedReport);
            reportFilter = savedReport.reportFilter;
            savedReports[index] = savedReport;
        }
        const newState = { ...this.state, selectedActivityFilterId, selectedEmployeeTypeIds, selectedJobTitleIds, selectedUnitIds, reports, savedReports, };
        this.setState({
            selectedActivityFilterId,
            selectedEmployeeTypeIds,
            selectedJobTitleIds,
            selectedUnitIds,
            reports,
            savedReports,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
        return {
            generalFilter: this.getGeneralFilterFromState(newState),
            reportFilter,
            showInFrontPage: false
        };
    };
    
    onRecordReportFilterDialogCancel = () => {
        // this.setState({ showRecordReportFilterDialog: false });
    };
    // #endregion Report Filter

    // #region Report Save
    handleSetSortData = (sortColumn: string, sortOrderIsAsc: boolean) => {
        const state = this.state;
        if (state.activeReportId) {
            const reports = state.reports.slice(0);
            const index = reports.findIndex(i => i.id === state.activeReportId);
            if (index < 0) return;
            const report = new ReportItem(reports[index]);
            report.sortColumn = sortColumn;
            report.sortOrderIsAsc = sortOrderIsAsc;
            reports[index] = report;
            const newState = { ...this.state, reports };
            this.setState({
                reports,
                listFilterIsSet: this.getListFilterIsSet(newState)
            });
        } else if (state.activeSavedReportId) {
            const savedReports = state.savedReports.slice(0);
            const index = savedReports.findIndex(i => i.id === state.activeSavedReportId);
            if (index < 0) return;
            const savedReport = new ReportItem(savedReports[index]);
            savedReport.sortColumn = sortColumn;
            savedReport.sortOrderIsAsc = sortOrderIsAsc;
            savedReports[index] = savedReport;
            const newState = { ...this.state, savedReports };
            this.setState({
                savedReports,
                listFilterIsSet: this.getListFilterIsSet(newState)
            });
        }
    };

    updateReportsAfterSave = (orgReportId: string, savedReport: ISavedReport, reportSharingType: ReportSharingType) => {
        if (!savedReport) return;
        const state = this.state;
        const savedReports = state.savedReports.filter(i => i.id !== orgReportId || i.reportSharingType !== reportSharingType);
        const report = state.reports.find(i => i.id === savedReport.reportId);
        if (!report) return;
        const newReport = ReportItem.createReportItemFromSavedReport(report, savedReport, reportSharingType);
        savedReports.push(newReport);
        ReportItem.sortReportItems(savedReports);
        this.setState({
            showReportSaveDialog: false,
            savedReports,
            activeReportId: "",
            activeSavedReportId: savedReport.id,
            reportFilterReport: newReport
        });
    };

    handleSaveAsReportsModifiedReport = async (saveAs: boolean, onGetReportSaveFilters: () => ISaveReportFilters) => {
        const state = this.state;
        const report = this.getActiveReport();
        if (!report) return;
        if (!saveAs) {
            const savedReport = await SaveReportDialog.saveReportToDb(report, this.getGeneralFilterFromState(state), state.activeCompanyId, ApplicationPermissionType.Record);
            this.updateReportsAfterSave(report.id, savedReport, report.reportSharingType);
        } else {
            this.setState({
                showReportSaveDialog: true,
                reportSaveDialogReport: report,
                reportSaveDialogReservedNames: state.savedReports.map(i => i.id).concat(state.reports.map(i => i.title)),
                reportSaveDialogGeneralFilter: this.getGeneralFilterFromState(state),
                reportSaveDialogOnGetReportSaveFilters: onGetReportSaveFilters
            });
        }
    };

    handleReportSaveDialogOk = (savedReport: ISavedReport, reportSharingType: ReportSharingType) => {
        this.updateReportsAfterSave("", savedReport, reportSharingType);
    };

    handleReportSaveDialogCancel = () => {
        this.setState({
            showReportSaveDialog: false
        });
    };
    // #endregion Report Save

    // #region Dashboard
    handleToggleShowDashboardNavPanel = () => {
        this.setState({ showDashBoardNavPanel: !this.state.showDashBoardNavPanel });
    };

    handleUpdateDashBoardPanels = async (panels: IPagePanel[]) => {
        this.setState({
            dashBoardPanels: panels
        });
    };

    handleSaveDashBoardPanels = async (panels: IPagePanel[]) => {
        await recordService.saveRecordPanels(panels);
        this.setState({
            dashBoardPanels: panels
        });
    };

    handleDashboardSavedFilterClick = (filterId: string) => {
        this.handleChangeActiveSavedFilter(filterId);
        this.setState({
            activeViewTypeId: RecordPageListViewTypeId.Records
        });
    };

    handleDashboardFilterClick = (filterId: string) => {
        this.handleChangeActiveFilter(filterId);
        this.setState({
            activeViewTypeId: RecordPageListViewTypeId.Records
        });
    };

    handleDashboardSavedReportClick = (reportId: string) => {
        this.handleChangeActiveSavedReport(reportId);
        this.setState({
            activeViewTypeId: RecordPageListViewTypeId.Reports
        });
    };

    handleDashboardReportClick = (reportId: string) => {
        this.handleChangeActiveReport(reportId);
        this.setState({
            activeViewTypeId: RecordPageListViewTypeId.Reports
        });
    };
    
    static getDefaultListFilter = (toDoItem: IFrontToDoItem): TDefaultListFilter => {
        if (!toDoItem) return null;
        if (toDoItem.id === "RecordUserUserAccountConnectedRecordCount") {
            return {
                filterId: Translations.UserRecords,
                generalFilter: {
                    activityFilterId: RecordPageListActivityFilterId.UserConnected
                }
            };
        }
        if (toDoItem.id === "RecordUserArchivedRecordCount") {
            return {
                filterId: Translations.UserRecords,
                generalFilter: {
                    activityFilterId: RecordPageListActivityFilterId.Archived
                }
            };
        }
        if (toDoItem.id === "RecordUserActiveRecordCount") {
            return {
                filterId: Translations.UserRecords,
                generalFilter: {
                    activityFilterId: RecordPageListActivityFilterId.Active
                }
            };
        }
        if (toDoItem.id === "RecordUserSavedRecordCount") {
            return {
                filterId: Translations.UserRecords,
                generalFilter: {
                    activityFilterId: RecordPageListActivityFilterId.None
                }
            };
        }
        if (toDoItem.id === "RecordUserUnapprovedFamiliarizationsCount") {
            return {
                filterId: Translations.UserRecords,
                generalFilter: {
                    activityFilterId: RecordPageListActivityFilterId.FamiliarizationNotApproved
                }
            };
        }
        return null;
    };
    
    static getDefaultReportFilter = (toDoItem: IFrontToDoItem): TDefaultReportFilter => {
        if (!toDoItem) return null;
        if (toDoItem.id === "RecordUserExpiredFurtherEducationCount") {
            return {
                reportId: HtmlReportId.ExpiredFurtherEducations,
            };
        }
        if (toDoItem.id === "RecordUserExpiredFamiliarizationCount") {
            return {
                reportId: HtmlReportId.ExpiredFamiliarizations,
            };
        }
        if (toDoItem.id === "RecordUserExpiringFurtherEducationCount") {
            return {
                reportId: "00000000-0000-0000-0000-000000000001",
                reportFilter: {
                    TrainingValidityExpiration: "6"
                }
            };
        }
        if (toDoItem.id === "RecordUserExpiringFamiliarizationCount") {
            return {
                reportId: "00000000-0000-0000-0000-000000000003",
                reportFilter: {
                    FamiliarizationValidityExpiration: "6"
                }
            };
        }
        const expiringQualificationCount = toDoItem.id === "RecordUserExpiringQualificationCount";
        const expiredQualificationCount = toDoItem.id === "RecordUserExpiredQualificationCount";
        if (expiringQualificationCount || expiredQualificationCount || toDoItem.id === "RecordUserMissingQualificationCount") {
            return {
                reportId: "00000000-0000-0000-0000-000000000004",
                reportFilter: {
                    TrainingValidityExpiration: expiringQualificationCount
                        ? "6"
                        : expiredQualificationCount
                            ? "1001"
                            : "1000"
                }
            };
        }
        return null;
    };
    
    handleToItemClick = (toDoItem: IFrontToDoItem) => {
        const defaultReportFilter = RecordPageList.getDefaultReportFilter(toDoItem);
        if (defaultReportFilter) {
            this.handleSetActiveViewType(RecordPageListViewTypeId.Reports, defaultReportFilter.reportId, defaultReportFilter.generalFilter, defaultReportFilter.reportFilter);
            return;
        }
        const defaultListFilter = RecordPageList.getDefaultListFilter(toDoItem);
        this.handleSetActiveViewType(RecordPageListViewTypeId.Records, defaultListFilter?.filterId, defaultListFilter?.generalFilter);
    };
    // #endregion Dashboard

    render() {
        const props = this.props;
        const state = this.state;
        const sessionState = this.props.appState.state;
        const companies = props.pageList ? props.pageList.companies : [];
        return (
            <PageContainer>
                <NavigationMenu
                    appState={props.appState}
                    activeMenuItem={HeaderMenuItem.UserRecords}
                    companies={companies}
                    activeCompanyId={state.activeCompanyId}
                    onChangeActiveCompany={this.handleChangeActiveCompanyId}
                />
                <PageContent>
                    <PageTopBar justifyContent="space-between">
                        <PageTabs
                            activeTabId={state.activeViewTypeId}
                            tabs={state.viewTypes}
                            changeTab={this.handleSetActiveViewType}
                        />
                        <UserMenu
                            appState={props.appState}
                            onLogout={props.onLogout}
                            onSetCulture={props.onSetCulture}
                            onRefreshSessionState={props.onRefreshSessionState}
                        />
                    </PageTopBar>
                    {state.activeViewTypeId !== RecordPageListViewTypeId.Dashboard &&
                        <PageListAndReportsContainer>
                            {state.activeViewTypeId === RecordPageListViewTypeId.Records &&
                                <RecordList
                                    savedFilter={state.activeSavedFilterId ? state.savedFilters.find(i => i.id === state.activeSavedFilterId) : null}
                                    sessionState={sessionState}
                                    dataId={state.dataId.toString(10)}
                                    companyId={state.activeCompanyId}
                                    units={state.units}
                                    jobTitles={state.jobTitles}
                                    listFilterIsSet={state.listFilterIsSet}
                                    companyFamiliarizations={state.companyFamiliarizations}
                                    companyFurtherEducationGroups={state.companyFurtherEducationGroups}
                                    selectedEmployeeTypeIds={state.selectedEmployeeTypeIds}
                                    selectedJobTitleIds={state.selectedJobTitleIds}
                                    selectedUnitIds={state.selectedUnitIds}
                                    selectedActivityFilterId={state.selectedActivityFilterId}
                                    sortColumn={state.sortColumn}
                                    sortOrderIsAsc={state.sortOrderIsAsc}
                                    sheetTaskType={state.sheetTaskType}
                                    onRefreshSessionState={props.onRefreshSessionState}
                                    onSetSortData={this.handleFilterSortData}
                                    onEmploymentSaved={this.handleEmploymentSaved}
                                    reportTabs={(
                                        <FilterTabs
                                            items={state.savedFilters}
                                            standardFilters={state.filters}
                                            selectedId={this.state.activeFilterId}
                                            selectedSavedId={this.state.activeSavedFilterId}
                                            onSetActiveItem={this.handleChangeActiveSavedFilter}
                                            onSetActiveStandardItem={this.handleChangeActiveFilter}
                                        />
                                    )}
                                    onOpenFiltersDialog={this.handleOpenRecordFilterDialog}
                                />
                            }
                            {state.activeViewTypeId === RecordPageListViewTypeId.Reports &&
                                <PageReportsContainer>
                                    <RecordPageListReport
                                        companyId={state.activeCompanyId}
                                        reports={state.activeReportId ? state.reports : state.savedReports}
                                        reportId={state.activeReportId ? state.activeReportId : state.activeSavedReportId}
                                        selectedEmployeeTypeIds={state.selectedEmployeeTypeIds}
                                        selectedJobTitleIds={state.selectedJobTitleIds}
                                        selectedUnitIds={state.selectedUnitIds}
                                        selectedActivityFilterId={state.selectedActivityFilterId}
                                        onSetSortData={this.handleSetSortData}
                                    />
                                    <ReportSettings
                                        filters={
                                            <RecordPageListReportFilterPanel
                                                report={state.reportFilterReport}
                                                units={state.units}
                                                activityFilters={state.reportActivityFilters}
                                                jobTitles={state.jobTitles}
                                                employeeTypes={state.employeeTypes}
                                                selectedActivityFilterId={state.selectedActivityFilterId}
                                                selectedEmployeeTypeIds={state.selectedEmployeeTypeIds}
                                                selectedJobTitleIds={state.selectedJobTitleIds}
                                                selectedUnitIds={state.selectedUnitIds}
                                                canRemoveSharedReports={sessionState.isSuperAdmin}
                                                onSaveReport={this.handleSaveAsReportsModifiedReport}
                                                onRemoveReport={this.handleRemoveSavedReport}
                                                onOk={this.onRecordReportFilterDialogOk}
                                                onCancel={this.onRecordReportFilterDialogCancel}
                                            />
                                        }
                                        reports={
                                            <PageNavMenuReportList
                                                canRemoveSharedReports={sessionState.isSuperAdmin}
                                                items={state.savedReports}
                                                standardReports={state.reports}
                                                activeItemId={state.activeSavedReportId}
                                                activeStandardItemId={state.activeReportId}
                                                showingSavedReports={true}
                                                title={Translations.Report}
                                                onSetActiveItem={this.handleChangeActiveSavedReport}
                                                onSetActiveStandardItem={this.handleChangeActiveReport}
                                            />
                                        } />
                                </PageReportsContainer>
                            }
                        </PageListAndReportsContainer>
                    }
                    {state.activeViewTypeId === RecordPageListViewTypeId.Dashboard &&
                        <DashboardPanelList
                            companyId={state.activeCompanyId}
                            applicationPermissionType={ApplicationPermissionType.Record}
                            canSharePanels={false}
                            hidden={!state.showDashBoardNavPanel}
                            panels={state.dashBoardPanels}
                            onUpdatePanels={this.handleUpdateDashBoardPanels}
                            onSavePanels={this.handleSaveDashBoardPanels}
                            onToggleMenuPanel={this.handleToggleShowDashboardNavPanel}
                        />
                    }
                    {state.activeViewTypeId === RecordPageListViewTypeId.Dashboard &&
                        <PageDashboard
                            title={Translations.UserRecordsDashboard}
                            settingsVisible
                            panels={state.dashBoardPanels}
                            companyId={state.activeCompanyId}
                            filters={state.filters}
                            savedFilters={state.savedFilters}
                            loadingReports={state.loadingReports}
                            reports={state.reports}
                            savedReports={state.savedReports}
                            chartItems={state.reportChartItems}
                            dashboardChart={null}
                            onSavedFilterClick={this.handleDashboardSavedFilterClick}
                            onFilterClick={this.handleDashboardFilterClick}
                            onSavedReportClick={this.handleDashboardSavedReportClick}
                            onReportClick={this.handleDashboardReportClick}
                            onShowChartPanelPropertiesDialog={() => alert()}
                            onToggleMenuPanel={this.handleToggleShowDashboardNavPanel}
                            onToggleSettingsDialog={this.handleOpenSettingsDialog}
                            onGetToDoItems={() => recordService.getRecordToDoItems(state.activeCompanyId)}
                            onStatisticsClick={this.handleToItemClick}
                        />
                    }
                </PageContent>
                <RecordPageListFilterDrawer
                    open={state.showRecordFilterDialog}
                    filter={state.recordFilterDialogFilter}
                    units={state.units}
                    activityFilters={state.activityFilters}
                    jobTitles={state.jobTitles}
                    employeeTypes={state.employeeTypes}
                    selectedActivityFilterId={state.selectedActivityFilterId}
                    selectedEmployeeTypeIds={state.selectedEmployeeTypeIds}
                    selectedJobTitleIds={state.selectedJobTitleIds}
                    selectedUnitIds={state.selectedUnitIds}
                    canRemoveSharedFilters={sessionState.isCompanyAdmin}
                    onSaveFilter={this.handleSaveListFilter}
                    onRemoveFilter={this.handleRemoveSavedFilter}
                    onOk={this.onRecordFilterDialogOk}
                    onCancel={this.onRecordFilterDialogCancel}
                />
                {state.showListFilterSaveDialog &&
                    <ListFilterSaveDialog
                        sessionState={sessionState}
                        companyId={state.activeCompanyId}
                        applicationPermissionType={ApplicationPermissionType.Record}
                        listFilter={state.listFilterSaveDialogFilter}
                        generalFilter={state.listFilterSaveDialogGeneralFilter}
                        sortColumn={state.sortColumn}
                        sortOrderIsAsc={state.sortOrderIsAsc}
                        reservedNames={state.listFilterSaveDialogReservedNames}
                        onGetGeneralFilter={state.listFilterSaveDialogOnGetGeneralFilter}
                        onOk={this.handleSaveListFilterDialogOk}
                        onCancel={this.handleSaveListFilterDialogCancel}
                    />
                }
                {state.showReportSaveDialog &&
                    <SaveReportDialog
                        sessionState={sessionState}
                        companyId={state.activeCompanyId}
                        applicationPermissionType={ApplicationPermissionType.Record}
                        report={state.reportSaveDialogReport}
                        generalFilter={state.reportSaveDialogGeneralFilter}
                        reservedNames={state.reportSaveDialogReservedNames}
                        onGetReportSaveFilters={state.reportSaveDialogOnGetReportSaveFilters}
                        onOk={this.handleReportSaveDialogOk}
                        onCancel={this.handleReportSaveDialogCancel}
                    />
                }
                {state.showSettingsDialog &&
                    <RecordSettingsDialog
                        sessionState={sessionState}
                        companyId={state.activeCompanyId}
                        settingsActions={state.settingsActions}
                        onClose={this.handleSettingsDialogOk}
                    />
                }
            </PageContainer>
        );
    }
}